<div class="css-Boton_primario-1 boton_primario">
    <button [disabled]="disabled" [ngClass]="{'button_primario':true, 'button_primario-diff1':disabled}"
        (click)="ejecutarFuncion()">
        <p [ngClass]="{'texto_boton_primario':true, 'texto_boton_primario-diff1':disabled}" class="">
            {{boton_texto}}</p>
    </button>
</div>